import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getSourcesQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/sourcesKeys.js';
import { sourceserviceClient } from '#pplx_generated/typespec/rest/sourceservice/client.js';
import { keepPreviousData } from '@tanstack/react-query';
const DEFAULT_SOURCES_LIMIT = 40;
export const MIN_SEARCH_CHARS = 1;
export const sourceQueryOptions = ({ reason, enabled = true, searchQuery, filterBy, limit: limitArg = DEFAULT_SOURCES_LIMIT, noLimit: noLimitArg, category, popular, custom, catalogMode, includePremiumSources, excludeIneligible, groupByFamily, productSurface, supportedExecEnvs, }) => {
    const search = searchQuery && searchQuery.length >= MIN_SEARCH_CHARS ? searchQuery : undefined;
    const noLimit = noLimitArg ? true : undefined;
    const limit = noLimit ? undefined : limitArg;
    const normalizedCatalogMode = catalogMode || undefined;
    const normalizedIncludePremiumSources = includePremiumSources || undefined;
    const normalizedExcludeIneligible = excludeIneligible || undefined;
    const normalizedGroupByFamily = groupByFamily || undefined;
    return {
        queryKey: getSourcesQueryKey({
            search,
            limit,
            filterBy,
            noLimit,
            category,
            popular,
            custom,
            catalogMode: normalizedCatalogMode,
            includePremiumSources: normalizedIncludePremiumSources,
            excludeIneligible: normalizedExcludeIneligible,
            groupByFamily: normalizedGroupByFamily,
            productSurface,
            supportedExecEnvs,
        }),
        queryFn: async ({ pageParam }) => {
            const { data, response, error } = await sourceserviceClient.GET('/rest/sources', reason, {
                params: {
                    query: {
                        search,
                        cursor: pageParam ?? undefined,
                        limit,
                        filter_by: filterBy,
                        no_limit: noLimit,
                        category,
                        popular,
                        custom,
                        use_catalog: normalizedCatalogMode,
                        include_premium_sources: normalizedIncludePremiumSources,
                        exclude_ineligible: normalizedExcludeIneligible,
                        group_by_family: normalizedGroupByFamily,
                        product_surface: productSurface,
                        supported_exec_envs: supportedExecEnvs?.join(','),
                    },
                },
            });
            if (error || !data) {
                throw new ApiClientsError('API_CLIENTS_ERROR', {
                    message: `Failed to fetch sources`,
                    cause: error,
                    status: response.status ?? 0,
                });
            }
            return data;
        },
        getNextPageParam: (lastPage) => lastPage?.next_cursor ?? undefined,
        initialPageParam: null,
        enabled,
        placeholderData: keepPreviousData,
    };
};
//# sourceMappingURL=sourceQueryOptions.js.map